import AdsErrorsFactory from '../../ads/Errors/factory.js'
import {SearchErrorsFactory} from '../Errors/factory.js'
import {NavigationDataRequestValueObject} from './NavigationDataRequestValueObject.js'
import {NavigationDataValueObject} from './NavigationDataValueObject.js'
import {NavigationLinksRequestValueObject} from './NavigationLinksRequestValueObject.js'
import {NavigationLinksValueObject} from './NavigationLinksValueObject.js'
import {SearchRequestValueObject} from './SearchRequestValueObject.js'
import {SubscriptionSearchRequestValueObject} from './SubscriptionSearchRequestValueObject.js'

export class SearchValueObjectsFactory {
  static navigationDataValueObject = ({nextPageUrl, prevPageUrl, searchUrl, items}) => {
    return new NavigationDataValueObject({
      nextPageUrl,
      prevPageUrl,
      searchUrl,
      items
    })
  }

  static navigationDataRequestValueObject = ({
    items,
    nextPageUrl,
    prevPageUrl,
    searchUrl,
    type,
    totalResults,
    currentPage
  }) => {
    return new NavigationDataRequestValueObject({
      items,
      nextPageUrl,
      prevPageUrl,
      searchUrl,
      type,
      totalResults,
      currentPage
    })
  }

  static navigationLinksRequestValueObject = ({currentPosition, id, type}) => {
    return new NavigationLinksRequestValueObject({
      currentPosition,
      id,
      type
    })
  }

  static navigationLinksValueObject = ({currentPosition, nextUrl, prevUrl, backUrl}) => {
    return new NavigationLinksValueObject({
      currentPosition,
      nextUrl,
      prevUrl,
      backUrl
    })
  }

  /**
   * @method
   * @param {Object} deps
   * @param {Object} deps.filters
   * @param {Object} deps.pagination
   * @param {Object} deps.sort
   * @return {SubscriptionSearchRequestValueObject}
   */
  static subscriptionSearchRequestValueObject = ({filters, pagination, sort}) => {
    SubscriptionSearchRequestValueObject.validate({
      filters,
      pagination,
      sort,
      getSubscriptionSearchResultsInvalidRequestAdsErrorFactory:
        AdsErrorsFactory.getSubscriptionSearchResultsInvalidRequestAdsError
    })

    return new SubscriptionSearchRequestValueObject({
      filters,
      pagination,
      sort
    })
  }

  static searchRequestValueObject = ({
    page,
    sortBy,
    sortOrder,
    batteryCapacity,
    bodyTypeIds,
    category1Id,
    category2Id,
    category3Id,
    categoryId,
    chargingTimeFastMode,
    chargingTimeStandardMode,
    city,
    cityId,
    colorIds,
    commitmentMonths,
    contractId,
    doors,
    drivenWheelsIds,
    electricAutonomy,
    environmentalLabels,
    equipments,
    excludedAdIds,
    excludedVehicles,
    fee,
    filteredOfferTypeId,
    financedPrice,
    fuelTypeIds,
    hasInstalment,
    hasOnlineFinancing,
    hasPhoto,
    hasPriceDrop,
    hasReservation,
    hasStock,
    hasWarranty,
    hp,
    isCertified,
    instalment,
    kms,
    litres,
    location,
    luggageCapacity,
    make,
    makeId,
    entry,
    maxTerms,
    model,
    modelVersionId,
    monthlySubscriptionFee,
    offerTypeId,
    onlyPeninsula,
    path,
    price,
    priceDrop,
    priceRank,
    province,
    provinceId,
    provinceIds,
    rating,
    searchText,
    seats,
    sellerTypeId,
    size,
    subscriptionVehicleState,
    targetBuyer,
    transmissionTypeId,
    vehicles,
    version,
    year
  } = {}) => {
    SearchRequestValueObject.validate({
      invalidRequestSearchErrorFactory: SearchErrorsFactory.invalidRequestSearchError,
      page,
      sortBy,
      sortOrder,
      categoryId,
      offerTypeId
    })

    return new SearchRequestValueObject({
      page,
      sortBy,
      sortOrder,
      batteryCapacity,
      bodyTypeIds,
      category1Id,
      category2Id,
      category3Id,
      categoryId,
      chargingTimeFastMode,
      chargingTimeStandardMode,
      city,
      cityId,
      colorIds,
      commitmentMonths,
      contractId,
      doors,
      drivenWheelsIds,
      electricAutonomy,
      environmentalLabels,
      equipments,
      excludedAdIds,
      excludedVehicles,
      ...(fee && {fee}),
      filteredOfferTypeId,
      financedPrice,
      fuelTypeIds,
      hasInstalment,
      hasOnlineFinancing,
      hasPhoto,
      hasPriceDrop,
      hasReservation,
      hasStock,
      hasWarranty,
      hp,
      isCertified,
      instalment,
      kms,
      litres,
      location,
      luggageCapacity,
      make,
      makeId,
      entry,
      maxTerms,
      model,
      modelVersionId,
      monthlySubscriptionFee,
      offerTypeId,
      onlyPeninsula,
      path,
      price,
      priceDrop,
      priceRank,
      province,
      provinceId,
      provinceIds,
      ...(rating && {rating}),
      searchText,
      seats,
      sellerTypeId,
      size,
      ...(subscriptionVehicleState && {subscriptionVehicleState}),
      targetBuyer,
      transmissionTypeId,
      vehicles,
      version,
      year
    })
  }
}
